// extracted by mini-css-extract-plugin
export var carrierTab = "_41-0";
export var carrierTabActive = "_41-1 _41-0";
export var carrierTabInactive = "_41-2 _41-0";
export var carrierTabLabel = "_41-3";
export var carrierTabLabelActive = "_41-4 _41-3";
export var carrierTabLabelInactive = "_41-5 _41-3";
export var carrierTabPercentage = "_41-6";
export var carrierTabPercentageActive = "_41-7 _41-6";
export var carrierTabPercentageInactive = "_41-8 _41-6";
export var carrierTabWinnable = "_41-9";
export var carrierTabWinnableActive = "_41-a _41-9";
export var carrierTabWinnableInactive = "_41-b _41-9";
export var comparisonContainer = "_41-d";
export var missingRateButton = "_41-n";
export var missingRateButtonActive = "_41-o _41-n";
export var missingRateButtonInactive = "_41-p _41-n";
export var missingRateButtonLabel = "_41-q";
export var missingRateButtonLabelActive = "_41-r _41-q";
export var missingRateButtonLabelInactive = "_41-s _41-q";
export var sidebar = "_41-c";
export var strategyButton = "_41-e";
export var strategyButtonActive = "_41-f _41-e";
export var strategyButtonDescription = "_41-k";
export var strategyButtonDescriptionActive = "_41-l _41-k";
export var strategyButtonDescriptionInactive = "_41-m _41-k";
export var strategyButtonInactive = "_41-g _41-e";
export var strategyButtonLabel = "_41-h";
export var strategyButtonLabelActive = "_41-i _41-h";
export var strategyButtonLabelInactive = "_41-j _41-h";
export var unitToggleButton = "_41-t";
export var unitToggleButtonActive = "_41-u _41-t";
export var unitToggleButtonInactive = "_41-v _41-t";
export var unitToggleButtonLabel = "_41-w";
export var unitToggleButtonLabelActive = "_41-x _41-w";
export var unitToggleButtonLabelInactive = "_41-y _41-w";